
import { defineComponent, PropType, ref } from "vue";
import { EventBus } from "@/eventBus";
import { Insight } from "@/models/insight";
import { Observation } from "@/store/reports/models";
import { Input } from "@progress/kendo-vue-inputs";
import { mapState } from "vuex";
import { useI18n } from "vue-i18n";

export default defineComponent({
  name: "TextInput",
  setup() {
    const input = ref(null);
    const form = ref(null);
    const { t } = useI18n({
      inheritLocale: true,
      useScope: "local",
    });
    return {
      input,
      form,
      t,
    };
  },
  components: {
    "k-input": Input,
  },
  data() {
    return {
      inputValue: this.prefill,
    };
  },
  props: {
    insight: {
      type: Object as PropType<Insight>,
    },
    prefill: {
      type: [String, Number],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState(["currentSlide"]),
    calculateMin() {
      if (this.insight.controller.min) {
        return this.insight.controller.min;
      }
      if (this.insight.controller.inputType === "number") {
        return 0;
      }
      return;
    },
  },
  mounted() {
    EventBus.on("apply-measurement", this.applyMeasurement);
  },
  unmounted() {
    EventBus.off("apply-measurement", this.applyMeasurement);
  },
  methods: {
    handleFocus() {
      if (this.insight?.suffix === "mm") {
        EventBus.emit("event-bridge-api", {
          eventName: "set-measuring-context",
          data: { key: this.insight.key },
        });
      } else {
        EventBus.emit("event-bridge-api", {
          eventName: "set-measuring-context",
          data: { key: null },
        });
      }
    },
    handleChange() {
      let value = this.inputValue;
      // If input type is number, convert an empty value to 'null' instead of 0
      if (this.insight.controller.inputType === "number") {
        value = this.inputValue ? this.inputValue : null;
      }
      const observation: Observation = {
        key: this.insight.key,
        title: this.t(
          `config.insight.slide.${this.currentSlide.tissueType}.${this.currentSlide.stain}.${this.insight.key}.title`
        ),
        value,
      };
      this.$emit("observationChange", observation);
    },
    applyMeasurement(data: { key: string; value: number }) {
      if (data.key === this.insight.key) {
        this.inputValue = data.value;
        this.handleChange();
      }
    },
  },
  watch: {
    isActive(newVal) {
      if (newVal && !this.disabled) {
        this.$refs.input.focus();
      }
    },
    prefill(newVal) {
      this.inputValue = newVal;
    },
  },
});
